export default {
  Restock: 'Restock',
  Hold: 'Hold',
  Dispose: 'Dispose',
  Cancel: 'Cancel',
  Other: 'Other',
  Quarantine: 'Quarantine'
}

export const ReturnReasonsApiEnum = {
  Restock: 1,
  Hold: 2,
  Dispose: 3,
  Cancel: 4,
  Other: 5,
  Quarantine: 2
}
